import type { FaireProductEntity } from "../../entity_types/product";

export const p_z2fcxwbjvv: FaireProductEntity = {
  token: "p_z2fcxwbjvv",
  type: "product",
  name: "Under $20 Add-On Demo Product",
  brandName: "Theme Demo Brand",
  imageUrl: "/images/placeholder-product.png",
  priceDollars: 18,
  description: "Placeholder product added to satisfy theme token references.",
  categoryTokens: ["cat_proto_theme-demo"],
  tags: ["theme-demo"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-reference-fix",
  },
};
